import script from "./overview-navigation-drawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./overview-navigation-drawer.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__